import Spinner from "@legacy/core/components/Spinner";
import { Component } from "react";
import ButtonGroup from "../../core/buttons/ButtonGroup";
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow";
import UniversalButton from "../../core/buttons/UniversalButton";
import TextField from "../../core/fields/TextField";


class VendorDeactivateForm extends Component {

    componentDidMount() {
        // Return to the previous scroll
        document.querySelector(".main").scrollTo(0, this.props.returnScroll || 0)
    }

    renderButtons = () => {
        const {vendor, deactivateData, requestAction, switchToPrimaryForm, submitting, errors, onFormDataChange, returnScroll} = this.props

        if (errors.unexpectedError) {
            return (
                <div className="data-panel__action-feedback">
                    <span className="text-invalid"><strong>An unexpected error occurred.</strong></span>
                </div>
            )
        }
        else {
            if (submitting) {
                return <Spinner centered={true} />
            }
            else {
                return (
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton type="danger" text="Deactivate" handler={event => requestAction("VENDOR_DEACTIVATE_SUBMIT")} />
                            <UniversalButton type="secondary" text="Cancel" handler={event => switchToPrimaryForm()} />
                        </ButtonGroupRow>
                    </ButtonGroup>
                )
            }
        }
    }

    render() {
        const {vendor, deactivateData, requestAction, switchToPrimaryForm, submitting, errors, onFormDataChange, returnScroll} = this.props

        return (
            <div className="data-panel-container data-panel-container--with-margin">
                <div className="data-panel" aria-label="Vendor Deactivate">
                    <div className="data-panel__form" aria-label="Vendor Deactivate Form">
                        <p className="data-panel__form__caption">Please confirm that you'd like to deactivate this vendor.<br /><br />Deactivated vendors do not show up in the list of available vendors when creating new Purchase Orders.</p>
                        <TextField
                            fieldName="deactivate_message"
                            fieldLabel="Deactivation Reason"
                            fieldValue={deactivateData.deactivate_message || ""}
                            fieldOnChange={deactivate_message => onFormDataChange("deactivate_message", deactivate_message || "")}
                            rows={3}
                            placeholder={`Why is ${vendor.name} being deactivated?`}
                            errors={errors}
                        ></TextField>
                    </div>
                    {this.renderButtons()}
                </div>
            </div>
        )
    }
}

export default VendorDeactivateForm
